export default __webpack_public_path__ + "static/media/file-video_darkGray3.00c5180e.svg";